import { OrderItemDataFragment, Enum_Orderitemaction_Action } from "data";
import { FirmwareIcon } from "components/Icons";
import { ActionComponent, ActionComponentVariant } from "components/ActionComponent";
import { useRegisterOrderItemAction } from "features/order-items/data/hooks/order-item-actions";

interface UpdateFirmwareActionProps {
  orderItem: OrderItemDataFragment;
  variant: ActionComponentVariant;
}

export const UpdateFirmwareAction = (props: UpdateFirmwareActionProps) => {
  const { orderItem, variant } = props;
  const { registerAction } = useRegisterOrderItemAction();
  return (
    <ActionComponent
      action={async () => {
        if (orderItem.id) {
          await registerAction({
            orderItem,
            action: {
              action: Enum_Orderitemaction_Action.UpdateFirmware,
            },
          });
        }
      }}
      variant={variant}
      actionIcon={<FirmwareIcon />}
      actionLabel='Update Firmware'
      data-cy='action-update-firmware'
    />
  );
};

UpdateFirmwareAction.defaultProps = {
  variant: "menu-item",
};
